// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OKd55","link":"Footer_link__GKiKn","iconCard":"Footer_iconCard__oH6ug"};